import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Lock = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      ref={forwardedRef}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00012 1.5C6.06713 1.5 4.50012 3.067 4.50012 5V6.5H4.00012C3.17169 6.5 2.50012 7.17157 2.50012 8V13C2.50012 13.8284 3.1717 14.5 4.00012 14.5H12.0001C12.8285 14.5 13.5001 13.8284 13.5001 13V8C13.5001 7.17157 12.8285 6.5 12.0001 6.5H11.5001V5C11.5001 3.067 9.93312 1.5 8.00012 1.5ZM10.5001 6.5V5C10.5001 3.61929 9.38083 2.5 8.00012 2.5C6.61941 2.5 5.50012 3.61929 5.50012 5V6.5H10.5001ZM3.50012 8C3.50012 7.72386 3.72398 7.5 4.00012 7.5H12.0001C12.2763 7.5 12.5001 7.72386 12.5001 8V13C12.5001 13.2761 12.2763 13.5 12.0001 13.5H4.00012C3.72398 13.5 3.50012 13.2761 3.50012 13V8Z"
      />
    </svg>
  )
})

export default Lock
